/**
 * Categorias asociadas de los trámites.
 *
 * Los endpoints que satisface son: category.
 *
 * @export
 * @class Categoria
 */
export class Categoria {
  id: number;
  nombre: string;
  descripcion: string;
  empresa_categoria?: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/categoria.model.ts